import { DateStr, DateTimeStr, toDateDiffRange, toDateStr } from '@mi-front/core';
import moment from 'moment-timezone';

export type SchedulesListCategory = 'spot' | 'mentions';

type BuildSchedulesListOrderFilterUrlParams = {
  stationSlug: string;
  category: SchedulesListCategory;
  order: string;
  /** Schedule datetime used as the center of the 30-day window. */
  scheduleDatetime: DateTimeStr | string;
  timezone: string;
};

/**
 * Builds a 30-day inclusive from/to window centered on the schedule day
 * (15 days before through 14 days after) in the station timezone.
 */
export function buildCenteredThirtyDayRange(
  scheduleDatetime: DateTimeStr | string,
  timezone: string,
) {
  const center = moment(scheduleDatetime).tz(timezone);

  return toDateDiffRange(
    toDateStr(center.clone().subtract(15, 'days')) as DateStr,
    toDateStr(center.clone().add(14, 'days')) as DateStr,
    timezone,
  );
}

/**
 * URL to the station schedules list (spot or mentions) filtered by order
 * over a 30-day range centered on the schedule datetime.
 */
export function buildSchedulesListOrderFilterUrl({
  stationSlug,
  category,
  order,
  scheduleDatetime,
  timezone,
}: BuildSchedulesListOrderFilterUrlParams): string {
  const { from, to } = buildCenteredThirtyDayRange(scheduleDatetime, timezone);
  const params = new URLSearchParams({
    from,
    to,
    order,
  });

  return `/audit/s/${stationSlug}/schedule/${category}?${params.toString()}`;
}
